import React, { useState } from 'react'

import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// Style Imports
import { pulse } from '../../style/animations'

// Other imports
import findInObject from '../../utils/findInObject'

const VideoLazyload = ({ children, className, displayPlayIcon, posterAlt, posterGatsbyImg, videoEmbedString }) => {
  const [videoClicked, setVideoClicked] = useState(false)

  const clickVideo = () => {
    if (!videoClicked) {
      setVideoClicked(true)
    }
  }

  const keyPressVideo = (e) => {
    if (!videoClicked && e.key === 'Enter') {
      setVideoClicked(true)
    }
  }

  const renderGatsbyImage = () => <GatsbyImage image={posterGatsbyImg.image} alt={posterAlt} />

  return (
    <div className={className}>
      {!videoClicked && (
        <button className="video-wrapper" aria-label="Play video" onClick={clickVideo} onKeyPress={keyPressVideo}>
          {!videoClicked && posterGatsbyImg && renderGatsbyImage(posterGatsbyImg)}
          {!videoClicked && displayPlayIcon && (
            <div className="play-icon-wrapper">
              <div className="play-icon-container ">
                <svg
                  className="play-icon"
                  width="45px"
                  height="45px"
                  viewBox="0 0 45 50"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg">
                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-514.000000, -5421.000000)" fill="#FFFFFF">
                      <g transform="translate(-1684.000000, -541.000000)">
                        <g>
                          <g transform="translate(1944.000000, 5842.000000)">
                            <path d="M258.946084,120.438272 L297.351499,142.197542 C299.5495,143.442926 299.5495,146.5571 297.351499,147.802484 L258.946084,169.561754 C256.748083,170.807138 254,169.249908 254,166.759426 L254,123.241456 C254,120.749832 256.748083,119.192888 258.946084,120.438272" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          )}
        </button>
      )}
      {videoClicked && videoEmbedString && htmr(videoEmbedString)}
      {videoClicked && children}
    </div>
  )
}

VideoLazyload.propTypes = {
  className: PropTypes.string.isRequired,
  displayPlayIcon: PropTypes.bool,
  posterAlt(props, propName, componentName) {
    if (!findInObject('posterGatsbyImg.alt', props) && typeof findInObject('posterAlt', props) !== 'string') {
      return new Error(
        'VideoLazyload requires a posterAlt attribute that is a string. Alternatively, you can pass a Gatsby Image object with an alt attribute.',
      )
    }
  },
  posterGatsbyImg: PropTypes.object,
  posterSrc: PropTypes.string,
  videoEmbedString: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  children: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]).isRequired,
}

VideoLazyload.defaultProps = {
  displayPlayIcon: false,
  gatsbyImg: false,
  children: false,
  videoEmbedString: false,
}

export default styled(VideoLazyload)`
  font-size: 0;
  width: 100%;

  button {
    background-color: transparent;
    cursor: pointer;
    border: none;
    font-size: 0;
    margin: 0;

    &:hover,
    &:focus {
      .play-icon-wrapper {
        animation: ${pulse} 0.35s 1;
      }
    }
  }

  .play-icon-wrapper {
    align-items: center;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: all 0.2s ease-in-out;
  }

  .play-icon-container {
    align-items: center;
    background-color: hsla(255, 100%, 100%, 0.35);
    border-radius: 50%;
    display: flex;
    height: 5.3125rem;
    justify-content: center;
    width: 5.3125rem;
  }

  .play-icon {
    position: relative;
    left: 0.1875rem;
  }
`
